module.exports = __webpack_public_path__ + "img/yellow-circle-table-1.74ca50e4.png";